
import Tracker from './Tracker';

export {Tracker};

const defaultTracker = new Tracker();

export default defaultTracker;



// WEBPACK FOOTER //
// ./lib/rlink-telemetry/index.js